import { useAuthStore } from '../auth/authStore';
import { useSelectedLocation } from './useSelectedLocation';

export interface UseWorkspaceLabelOptions {
  fallback?: string;
  loadingLabel?: string;
}

export function useWorkspaceLabel(options: UseWorkspaceLabelOptions = {}): string {
  const { fallback = 'Workspace', loadingLabel = 'Loading…' } = options;
  const isLoading = useAuthStore((s) => s.isLoading);
  const selected = useSelectedLocation();

  if (isLoading) return loadingLabel;
  if (selected?.name.trim()) return selected.name.trim();
  return fallback;
}

export function useWorkspaceSublabel(): string | undefined {
  const selected = useSelectedLocation();
  if (!selected) return undefined;

  const parts = [selected.city, selected.state].filter(Boolean);
  if (parts.length > 0) return parts.join(' · ');
  if (selected.full_address?.trim()) return selected.full_address.trim();
  return selected.ascend_id ?? undefined;
}
